<template>
  <div class="profile-page">
    

    <!-- Profile Content -->
    <div class="container profile-container">
      <div class="row justify-content-center">
        <div class="col-lg-8 col-md-10">
          <!-- Profile Card -->
          <div class="card profile-card shadow-lg">
            <!-- Profile Header -->
            <div class="profile-header text-center">
              <div class="avatar-wrapper">
                <i class="fas fa-user-circle avatar"></i>
              </div>
              <h2 class="profile-name">{{ userData.member.name }}</h2>
              <div class="profile-meta">
                <span class="badge bg-light text-dark">{{ userData.member.gender }}, {{ calculateAge(userData.member.date_of_birth) }} yrs</span>
                <span class="member-since">Member since {{ formatDate(userData.member.date_of_joining) }}</span>
              </div>
            </div>

            <!-- Profile Details -->
            <div class="profile-details">
              <div class="detail-item">
                <i class="fas fa-envelope"></i>
                <span>{{ userData.member.email }}</span>
              </div>
              <div class="detail-item">
                <i class="fas fa-phone"></i>
                <span>{{ userData.member.telephone }}</span>
              </div>
              <div class="detail-item">
                <i class="fas fa-map-marker-alt"></i>
                <span>{{ userData.member.address }}</span>
              </div>
              <div class="detail-item">
                <i class="fas fa-church"></i>
                <span>{{ userData.member.church ?? "Namirembe Church" }}</span>
              </div>
            </div>

            <!-- Actions -->
            <div class="profile-actions text-center">
              <button @click="showChangePasswordModal" class="btn btn-primary">
                <i class="fas fa-key"></i> Change Password
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Change Password Modal -->
    <div class="modal fade" id="changePasswordModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Change Password</h5>
            <button type="button" class="btn" data-dismiss="modal" aria-label="Close">X</button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="changePassword">
              <div class="mb-3">
                <label for="currentPassword" class="form-label">Current Password</label>
                <input type="password" class="form-control" id="currentPassword" v-model="password.current" required>
              </div>
              <div class="mb-3">
                <label for="newPassword" class="form-label">New Password</label>
                <input type="password" class="form-control" id="newPassword" v-model="password.new" required>
              </div>
              <div class="mb-3">
                <label for="confirmPassword" class="form-label">Confirm New Password</label>
                <input type="password" class="form-control" id="confirmPassword" v-model="password.confirm" required>
                <div v-if="password.new && password.confirm && password.new !== password.confirm" class="text-danger small mt-1">
                  Passwords don't match
                </div>
              </div>
              <div class="d-grid gap-2">
                <button type="submit" class="btn btn-primary" :disabled="password.new !== password.confirm">
                  Update Password
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap';
import axios from 'axios'

export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      password: {
        current: '',
        new: '',
        confirm: ''
      },
      passwordModal: null
    }
  },
  mounted() {
    this.passwordModal = new Modal(document.getElementById('changePasswordModal'));
  },
  methods: {
    
    calculateAge(dob) {
      return Math.floor((new Date() - new Date(dob)) / (1000 * 60 * 60 * 24 * 365.25));
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: 'long' });
    },
    showChangePasswordModal() {
      this.passwordModal.show();
    },
    async changePassword() {
      // Implement password change logic here
      console.log("Changing password...");
      // Reset form
      // this.password = { current: '', new: '', confirm: '' };
      let formData = new FormData();
      formData.append("id", this.userData.member.id);
      formData.append("password", this.password.new);
      let url = "/updateserpassword";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.passwordModal.hide();
      
      // Show success message
      this.$toast.success("Password changed successfully!", {
        position: "top-right",
        duration: 3000
      });
    }
    });
  }
}
}
</script>

<style scoped>
.profile-page {
  position: relative;
  min-height: 100vh;
  padding-bottom: 50px;
}

.profile-cover {
  height: 300px;
  width: 100%;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #5e72e4 0%, #825ee4 100%);
}

.cover-shapes {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.cover-shapes .shape {
  position: absolute;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
}

.cover-shapes .shape:nth-child(1) {
  width: 150px;
  height: 150px;
  top: -50px;
  left: -50px;
}

.cover-shapes .shape:nth-child(2) {
  width: 200px;
  height: 200px;
  bottom: -80px;
  right: -80px;
}

.cover-shapes .shape:nth-child(3) {
  width: 100px;
  height: 100px;
  top: 20%;
  right: 10%;
}

.profile-container {
  position: relative;
  margin-top: 10px;
}

.profile-card {
  border-radius: 15px;
  overflow: hidden;
  border: none;
}

.profile-header {
  padding: 10px 10px 10px;
  background: white;
}

.avatar-wrapper {
  margin: 0 auto;
  width: 50px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.avatar {
  font-size: 60px;
  color: #5e72e4;
  background: white;
  border-radius: 50%;
  border: 5px solid white;
}

.profile-name {
  font-weight: 700;
  margin-bottom: 10px;
  color: #2d3748;
}

.profile-meta {
  margin-bottom: 20px;
}

.badge {
  padding: 5px 10px;
  font-weight: 500;
  margin-right: 10px;
}

.member-since {
  color: #718096;
  font-size: 0.9rem;
}

.profile-details {
  padding: 20px;
  background: #f8f9fa;
}

.detail-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #e2e8f0;
}

.detail-item:last-child {
  border-bottom: none;
}

.detail-item i {
  width: 30px;
  color: #5e72e4;
  font-size: 1.1rem;
}


.profile-actions {
  padding: 20px;
  background: #f8f9fa;
  border-top: 1px solid #edf2f7;
}

.btn-primary {
  background-color: #5e72e4;
  border-color: #5e72e4;
  padding: 8px 20px;
  border-radius: 50px;
  font-weight: 500;
}

.btn-primary:hover {
  background-color: #4a5acf;
  border-color: #4a5acf;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .profile-cover {
    height: 250px;
  }
  
  .avatar-wrapper {
    width: 100px;
    height: 100px;
    margin-top: -60px;
  }
  
  .avatar {
    font-size: 100px;
  }
  
  .profile-name {
    font-size: 1.5rem;
  }
}
</style>